import type { RouteLocationNormalizedLoaded } from 'vue-router';
import { Route } from '@/modules/core/enums/route.enum.ts';

/*
 Vue Router очищает путь в адресной строке браузера при переходе на "/:pathMatch(.*)*" по name.
 Данная функция позволяет переписать его после успешной маршрутизации.
*/
export function saveUrlForErrorPage(to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) {
  if (to.name === Route.ErrorPage && from.name) {
    history.replaceState(history.state, '', from.fullPath);
  }
}
